import { ContextBar } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export const HeaderTitle: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <ContextBar.SiteNav>
      <ContextBar.SiteNav.Item label={t('app:header:title')} noLink title />
    </ContextBar.SiteNav>
  );
};
